export const defaultLayout = [
  {
    i: "sales",
    x: 0,
    y: 0,
    w: 3,
    h: 5,
    minW: 3,
    maxW: 4,
    minH: 4,
    maxH: 5,
  },
  {
    i: "gmp",
    x: 3,
    y: 0,
    w: 3,
    h: 5,
    minW: 3,
    maxW: 4,
    minH: 4,
    maxH: 5,
  },
  {
    i: "oee",
    x: 6,
    y: 0,
    w: 3,
    h: 5,
    minW: 3,
    maxW: 4,
    minH: 4,
    maxH: 5,
  },
  {
    i: "pl",
    x: 9,
    y: 0,
    w: 3,
    h: 5,
    minW: 3,
    maxW: 4,
    minH: 4,
    maxH: 5,
  },
  {
    i: "netmargin",
    x: 0,
    y: 9,
    w: 3,
    h: 5,
    minW: 3,
    maxW: 4,
    minH: 4,
    maxH: 5,
  },

  {
    i: "successChart",
    x: 0,
    y: 12,
    w: 6,
    h: 8,
    minW: 4,
    maxW: 8,
    minH: 5,
    maxH: 10,
  },
  {
    i: "barChart",
    x: 6,
    y: 9,
    w: 6,
    h: 8,
    minW: 4,
    maxW: 8,
    minH: 5,
    maxH: 10,
  },
  {
    i: "salesChart",
    x: 0,
    y: 16,
    w: 6,
    h: 8,
    minW: 4,
    maxW: 8,
    minH: 5,
    maxH: 10,
  },
  {
    i: "orderChart",
    x: 6,
    y: 16,
    w: 6,
    h: 8,
    minW: 4,
    maxW: 8,
    minH: 5,
    maxH: 10,
  },
]

// MONTH DROPDOWN
export const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
]
